import { ButtonLink } from "@/components/ui/Button";
import { Container } from "@/components/ui/Container";

export default function NotFoundPage() {
  return (
    <Container className="flex min-h-[70vh] flex-col justify-center py-20">
      <p className="text-sm font-bold uppercase tracking-wide text-mint-dark">404</p>
      <h1 className="mt-3 text-4xl font-bold md:text-5xl">Page not found</h1>
      <p className="mt-5 max-w-2xl text-lg text-ink-soft">
        The page may have moved or the address may be incomplete. You can continue from the
        homepage, product overview, or contact page.
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <ButtonLink to="/">Go home</ButtonLink>
        <ButtonLink to="/product" variant="secondary">
          View product
        </ButtonLink>
        <ButtonLink to="/contact" variant="secondary">
          Contact us
        </ButtonLink>
      </div>
    </Container>
  );
}
